import React from 'react';
import { T, fontBody } from '../tokens';

const CHANNEL_FALLBACK_LABEL = {
  instagram_comment: 'Default fallback — fires on every Instagram comment when no keyword automation matches',
  instagram_dm: 'Default fallback — fires on every Instagram DM when no keyword automation matches',
  facebook_comment: 'Default fallback — fires on every Facebook comment when no keyword automation matches',
  facebook_messenger: 'Default fallback — fires on every Messenger message when no keyword automation matches',
  comment_reply: 'Default fallback — fires on every comment when no keyword automation matches',
  dm_reply: 'Default fallback — fires on every DM when no keyword automation matches',
  comment_dm: 'Fires automatically after every public comment reply',
};

export default function KeywordTags({ keywords, emptyLabel, templateType, isSystemDefault, isChannelDefault, triggerChannel }) {
  const tags = (keywords || []).filter(Boolean);
  const isDefault = isChannelDefault || isSystemDefault;

  if (!tags.length) {
    const fallbackKey = triggerChannel || templateType;
    const label = (isDefault && CHANNEL_FALLBACK_LABEL[fallbackKey]) || emptyLabel;
    if (!label) return null;
    return (
      <div style={{
        display: 'flex', alignItems: 'center', gap: 6,
        marginTop: 12, padding: '6px 10px', borderRadius: 8,
        background: '#F0FDF4', border: '1px solid #BBF7D0',
        fontFamily: fontBody, fontSize: 11.5, fontWeight: 600,
        color: '#15803D',
        maxWidth: '100%', overflow: 'hidden',
      }}
      >
        <span style={{ width: 6, height: 6, borderRadius: 999, background: '#22C55E', flexShrink: 0 }} />
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {label}
        </span>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 12 }}>
      {tags.map((tag) => (
        <span
          key={tag}
          style={{
            fontFamily: fontBody,
            fontSize: 11.5,
            fontWeight: 600,
            color: '#fff',
            background: T.ink,
            padding: '4px 10px',
            borderRadius: 6,
          }}
        >
          {tag}
        </span>
      ))}
    </div>
  );
}
